import './index.css'
import React from 'react'

/**
 * A delta indicator component showing positive or negative change with directional arrow
 * @param type - The type of delta ('positive' or 'negative') which determines arrow direction and color
 * @param value - The value to display alongside the delta indicator
 * @returns A span element containing an SVG arrow icon and the delta value
 */
const Delta = ({ type, value }) => (
  <span className="Delta">
    <svg className={`Delta_Icon Delta_Icon--${type}`} width="10" height="6">
      <path
        d="M3.715 1.13c.71-.844 1.864-.838 2.568 0l2.572 3.059c.709.843.39 1.527-.723 1.527H1.866c-1.108 0-1.427-.69-.723-1.527l2.572-3.06z"
        fill="currentcolor"
        transform={
          type === 'negative' ? 'scale(1, -1) translate(0, -6)' : undefined
        }
      />
    </svg>
    {value}
  </span>
)

export default React.memo(Delta)
